module.exports = __webpack_public_path__ + "img/change@2x.e7957aa5.png";